import React, { useState } from 'react'

import { Tooltip, List, Divider, Modal, Input } from 'antd'
import { Button } from '@digital/ui'

export interface ModalJustificativaProps {
    justificativa?: string
}

const ModalJustificativa = ({ justificativa }: ModalJustificativaProps) => {
    const [exibirModal, setExibirModal] = useState(false)

    const showModal = () => {
        setExibirModal(true)
    }

    const cancelModal = () => {
        setExibirModal(false)
    }

    return (
        <>
            <Tooltip title="Justificativa">
                <Button
                    onClick={showModal}
                    icon="messaging-comments"
                    className={justificativa ? 'has-comments' : ''}
                />
            </Tooltip>
            <Modal
                title="Justificativa"
                visible={exibirModal}
                onCancel={cancelModal}
                footer={null}
            >
                <Input.TextArea
                    value={justificativa}
                    autosize={{ minRows: 5 }}
                    disabled
                />
            </Modal>
        </>
    )
}

export default ModalJustificativa